export const CONFIG_MINIMIZE_MENU = 'CONFIG_MINIMIZE_MENU'

export const CONFIG_TOGGLE_THEME = 'CONFIG_TOGGLE_THEME'

export const CONFIG_DEFAULT_LANG = 'CONFIG_DEFAULT_LANG'
